import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c7a4c22&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/news_center.css?vue&type=style&index=0&id=1c7a4c22&prod&scoped=true&lang=css&external"
import style1 from "../../assets/css/box.css?vue&type=style&index=1&id=1c7a4c22&prod&scoped=true&lang=css&external"
import style2 from "./index.vue?vue&type=style&index=2&id=1c7a4c22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7a4c22",
  null
  
)

export default component.exports